import React from 'react';
import { Box, Typography, Stack, TextField, Autocomplete } from '@mui/material';
import type { ProcedureType } from '../../../../../../services/ConfigurationService/types';

interface ProcedureInfoSectionProps {
  procedures: ProcedureType[];
  proceduresLoading: boolean;
  selectedProcedure: ProcedureType | null;
  code: string;
  description: string;
  isEncounterCancelled: boolean;
  onProcedureChange: (procedure: ProcedureType | null) => void;
  onDescriptionChange: (value: string) => void;
}

export const ProcedureInfoSection: React.FC<ProcedureInfoSectionProps> = ({
  procedures,
  proceduresLoading,
  selectedProcedure,
  code,
  description,
  isEncounterCancelled,
  onProcedureChange,
  onDescriptionChange,
}) => (
  <Box>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
      Procedure Information
    </Typography>
    <Stack spacing={2}>
      <Autocomplete
        options={procedures || []}
        getOptionLabel={(option) => `${option.code} - ${option.description}`}
        value={selectedProcedure}
        onChange={(_, newValue) => onProcedureChange(newValue)}
        loading={proceduresLoading}
        disabled={isEncounterCancelled}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Procedure"
            size="small"
            placeholder="Select a procedure..."
            required
            helperText={isEncounterCancelled ? 'Read-only (Encounter Cancelled)' : 'Select a procedure to auto-fill code and description'}
            sx={{
              '& .MuiInputBase-input': {
                backgroundColor: isEncounterCancelled ? '#f5f5f5' : 'inherit'
              }
            }}
          />
        )}
        sx={{
          '& .MuiAutocomplete-input': {
            color: isEncounterCancelled ? '#9e9e9e' : 'inherit'
          }
        }}
      />
      <Stack direction="row" spacing={2}>
        <TextField
          label="Code"
          size="small"
          value={code}
          sx={{ flex: 1 }}
          InputProps={{ readOnly: true }}
          helperText="Auto-filled from procedure selection"
          disabled
        />
        <TextField
          label="Description"
          size="small"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          disabled={isEncounterCancelled}
          sx={{ flex: 2 }}
          helperText={isEncounterCancelled ? 'Read-only (Encounter Cancelled)' : 'Auto-filled, can be customized'}
        />
      </Stack>
    </Stack>
  </Box>
);
